export default __webpack_public_path__ + "static/media/login-elsa-logo-wordmark.fa1fdc7c.svg";